/* eslint-disable no-undef */

export const qplayerDomain = process.env.REACT_APP_QPLAYER_DOMAIN;
export const qplayerLoaderUrl = process.env.REACT_APP_QPLAYER_LOADER;
export const qplayerWebComponentLoaderUrl = process.env.REACT_APP_QPLAYER_WEB_COMPONENT_LOADER;
export const qplayerRestrictedAccounts = process.env.REACT_APP_QPLAYER_RESTRICTED_ACCOUNTS;
export const playerConfigDomain = process.env.REACT_APP_PLAYER_CONFIG_DOMAIN;
export const publicDataDomain = process.env.REACT_APP_PUBLIC_DATA_DOMAIN;
export const chatPublicDomain = process.env.REACT_APP_CHAT_PUBLIC_DOMAIN;
export const notificationSocketDomain = process.env.REACT_APP_NOTIFICATION_WEBSOCKET_DOMAIN;
export const play2ConfigDomain = process.env.REACT_APP_PLAY2_CONFIG_DOMAIN;
export const gobrainConfig = process.env.REACT_APP_GOBRAIN_CONFIG;
export const gobrainLiveConfig = process.env.REACT_APP_GOBRAIN_LIVE_CONFIG;
export const defaultLivePreCover = process.env.REACT_APP_PRE_COVER_URL;
export const defaultLivePostCover = process.env.REACT_APP_POST_COVER_URL;
